module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAF0lEQVQImWMsKyv7z4AHMOGTZGBgYAAAlwgCZbcsyqcAAAAASUVORK5CYII="